<div>
  <table #listDataTable mat-table class="book-table mat-elevation-z8" matSort 
    [dataSource]="bookDisplay" >
    <!-- Book type icon either an audio book or a Kindle eBook-->
    <ng-container matColumnDef="type" class="book-type-col">
      <th mat-header-cell *matHeaderCellDef >Type</th>
      <td mat-cell name="type" *matCellDef="let book">
        <mat-icon>{{ book.type == "Audible Book" ? "hearing" : "book" }} </mat-icon>
      </td>
    </ng-container>
    <!-- the book Title -->
    <ng-container matColumnDef="title">
      <th mat-header-cell *matHeaderCellDef >Title</th>
      <td mat-cell *matCellDef="let book" (click)="onTitleClick(book, $event)">{{book.title}}</td>
    </ng-container>
    <!-- Book Series and reading order (if applicable) -->
    <ng-container matColumnDef="series">
      <th mat-header-cell *matHeaderCellDef >Series</th>
      <td mat-cell name="series" *matCellDef="let book">{{ getSeriesDisplay(book.series) }}
      </td>
    </ng-container>
    <!-- Checkbox if book added by the current User -->
    <ng-container matColumnDef="addedByMe">
      <th mat-header-cell *matHeaderCellDef>Added By Me</th>
      <td mat-cell *matCellDef="let book">
        <mat-checkbox [checked]="book.addedByMe" (change)="onAddedByMeChange($event, book)"></mat-checkbox>
      </td>
    </ng-container>
    <!-- Checkbox if the current User in the isInterested JSON array -->
    <ng-container matColumnDef="imInterested">
      <th mat-header-cell *matHeaderCellDef>I'm Interested</th>
      <td mat-cell *matCellDef="let book">
        <mat-checkbox [checked]="book.imInterested"
          (change)="onCheckBoxChange('imInterested',$event, book)"></mat-checkbox>
      </td>
    </ng-container>
    <!-- Checkbox if the current User in the hasRead JSON array -->
    <ng-container matColumnDef="iHaveRead">
      <th mat-header-cell *matHeaderCellDef>I Have Read</th>
      <td mat-cell *matCellDef="let book">
        <mat-checkbox [checked]="book.iHaveRead" (change)="onCheckBoxChange('iHaveRead',$event, book)"></mat-checkbox>
      </td>
    </ng-container>
    
    <!-- End of Column Definitions -->
    <tr mat-header-row sticky *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
  
  <div class="book-table-footer">
  </div>
</div>